// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// app modules: components
import Button from 'components/Button';
import Heading from 'components/Heading';
import Icon from 'components/Icon';

// assets
import CssAuthorFollowLinks from './AuthorFollowLinks.scss';
import { COLOURS } from '../../constants';

class AuthorFollowLinksComponent extends Component {
  static propTypes = {
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    personName: PropTypes.string,
    personFirstName: PropTypes.string,
    spotify: PropTypes.string,
  };

  static defaultProps = {
    facebook: '',
    twitter: '',
    instagram: '',
    personName: '',
    personFirstName: '',
    spotify: '',
  };

  renderFacebookButton() {
    const { facebook } = this.props;

    return (
      <a
        className="follow-links__link"
        href={`https://www.facebook.com/${facebook}`}
        title="facebook"
        target="_blank"
      >
        <Icon
          className="follow-links__icon"
          fill={COLOURS.SOLID_GREY}
          name="facebook-grey"
          height="28"
          width="28"
        />
      </a>
    );
  }

  renderTwitterButton() {
    const { twitter } = this.props;

    return (
      <a
        className="follow-links__link"
        href={`https://www.twitter.com/${twitter}`}
        title="twitter"
        target="_blank"
      >
        <Icon fill={COLOURS.SOLID_GREY} className="follow-links__x" name="x-big" width="26" />
      </a>
    );
  }

  renderInstagramButton() {
    const { instagram } = this.props;
    const slicedInstagramName = instagram.slice(1);

    return (
      <a
        className="follow-links__link"
        href={`https://www.instagram.com/${slicedInstagramName}`}
        title="instagram"
        target="_blank"
      >
        <Icon
          className="follow-links__icon"
          fill={COLOURS.SOLID_GREY}
          name="instagram-grey"
          height="30"
          width="30"
        />
      </a>
    );
  }

  renderSpotifyButton() {
    const { spotify, personFirstName } = this.props;
    const name = `${personFirstName}'s`;

    return spotify ? (
      <div className="follow-links__spotify">
        <Heading withDash className="margin-bottom-20">
          What&apos;s playing in {name} kitchen
        </Heading>
        <Button
          href={spotify}
          target="_blank"
          themeType="outline"
          themeName="energized"
          title="spotify playlist"
          size="large"
        >
          Listen to {name} playlist
        </Button>
      </div>
    ) : null;
  }

  render() {
    const { facebook, twitter, instagram, personName } = this.props;
    const facebookButton = facebook ? this.renderFacebookButton() : null;
    const twitterButton = twitter ? this.renderTwitterButton() : null;
    const instagramButton = instagram ? this.renderInstagramButton() : null;
    const spotifyButton = this.renderSpotifyButton();

    return facebookButton || twitterButton || instagramButton ? (
      <div className="follow-links">
        <Heading withDash className="margin-bottom-20">
          follow {personName}
        </Heading>
        <div className="follow-links__socials">
          {facebookButton}
          {twitterButton}
          {instagramButton}
        </div>

        {spotifyButton}
      </div>
    ) : null;
  }
}

export default withStyles(CssAuthorFollowLinks)(AuthorFollowLinksComponent);
